// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"0743a284","474":"0743a284"}[chunkId] + ".chunk.css";
};